import AsyncStorage from '@react-native-async-storage/async-storage';

export interface WidgetData {
  identifier: string;
  seq?: number;
}

export class WidgetStore {
  private static buildKey(siteId: string, userId: string): string {
    return `widget:${siteId}:${userId}`;
  }

  static async get(siteId: string, userId: string): Promise<WidgetData[]> {
    try {
      const value = await AsyncStorage.getItem(this.buildKey(siteId, userId));
      if (value) {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      }
      return [];
    } catch {
      return [];
    }
  }

  static async set(siteId: string, userId: string, list: WidgetData[]): Promise<void> {
    const jsonString = JSON.stringify(list);
    await AsyncStorage.setItem(this.buildKey(siteId, userId), jsonString);
  }
}
